const collator = new Intl.Collator(undefined, { numeric: true });

/**
 * Can be useful to sort string
 * compare string alphabetically
 * With this compare "10" comes after "5" (that's not the case with regular compare)
 *
 * @param {a} string
 * @param {b} string
 * @returns {string}
 */
export function naturalCompare(a, b) {
  return collator.compare(a, b);
}
